// store/slices/customerSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import CustomerService from '@/services/customers';

export interface Customer {
  id: string;
  name: string;
  customers: any[];
  site_groups: any[];
}

interface CustomerState {
  data: Customer | null; // Changed to array to support multiple customers
  loading: boolean;
  error: string | null;
  fetched: boolean;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: CustomerState = {
  data: null,
  loading: false,
  error: null,
  fetched: false,
  status: 'idle'
};

// Async thunk for fetching customer data based on user
export const fetchCustomers = createAsyncThunk<
  CustomerState,
  { userId: string; accessToken?: string }
>(
    'customer/fetchCustomers', async ({userId, accessToken}) => {
    
    
    const customerService = new CustomerService(undefined, accessToken);
    const apiResponse = await customerService.getCustomerSitegroups(userId);
    console.log('fetchCustomerInfo: fetched details', apiResponse);

    return apiResponse;
  },
  {
    // condition to prevent duplicate requests
    condition: (_arg, { getState }) => {
      const state = getState() as { customer: CustomerState };
           return state.customer.status === 'idle' && !state.customer.fetched;
    },
  }
);

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    clearCustomer: (state) => {
      state.data = null;
      state.error = null;
      state.fetched = false;
      state.status = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.status = 'loading';
        state.loading = true;
        state.error = null;
        state.fetched = false;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        const payload = action.payload as unknown;
        console.log('customerSlice: fetched customers', payload);
        state.loading = false;
        state.data = payload as Customer;
        state.fetched = true;
        state.status = 'succeeded';
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch customer';
        state.fetched = true;
      });
  },
});

export const { clearCustomer } = customerSlice.actions;
export default customerSlice.reducer;